import { defineStore } from 'pinia';
import { piniaOidcCreateStoreModule } from 'pinia-oidc';
import { oidcSettings } from '@/config/oidc';

const events = {
  userLoaded: user => {
    const store = useOidc();
    store.access_token = user.access_token;
  },
  accessTokenExpired: () => {
    if (window.location.pathname !== "/start") {
      window.location.href = "/start";
    }
  }
};

export const useOidc = defineStore(
  "oidc", piniaOidcCreateStoreModule(oidcSettings, {}, events)
);
